import React from 'react';
import PropTypes from 'prop-types';

class TextFieldWrapper extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isActive: false,
            isPasswordVisible: false
        };
    }

    togglePasswordVisibilityMode = () => {
        this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
    }

    onFocus = (e) => {
        const { onFocus } = this.props;
        this.setState({ isActive: true });
        if (onFocus) {
            onFocus(e);
        }
    }

    onBlur = () => {
        const {
            value,
            onChange,
            error,
            shouldBlurBeFired,
            onBlur,
            name,
            skipOnChangeAfterOnBlur
        } = this.props;
        this.setState({ isActive: false });
        if (skipOnChangeAfterOnBlur !== true) {
            onChange({ target: { name, value } });
        }

        if (shouldBlurBeFired && typeof shouldBlurBeFired === 'boolean') {
            if (!value) onBlur(name, value);
            return;
        }

        if (value || (shouldBlurBeFired && typeof shouldBlurBeFired === 'function' && shouldBlurBeFired())) {
            onBlur(name, value);
        }
    }

    onKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 13) {
            if (this.props.onEnter) {
                this.setState({ isActive: false });
                this.props.onEnter();
            }
        } else if (keyCode === 27) {
            if (this.props.onEsc) {
                this.props.onEsc(event);
            }
        }

        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
    }

    onKeyUp = (e) => {
        if (this.props.onLengthValidate) {
            this.props.onLengthValidate(e);
        }
    }

    isPassword = () => {
        return this.props.type === 'password';
    }

    render() {
        const {
            name,
            error,
            info,
            onChange,
            onInput,
            autoComplete,
            value,
            type,
            disabled,
            readOnly,
            autoFocus,
            maxLength,
            tabIndex,
            id,
            label,
            required,
            sizeType,
            className,
            height,
            inputClassName
        } = this.props;

        const {
            isPasswordVisible,
            isActive
        } = this.state;

        let { placeholder } = this.props;

        let appliedType = type,
            invalidClass = '',
            wrapperClass = 'text-field-wrapper',
            labelClass = 'text-field-wrapper_label',
            msg = label,
            inputClass = `text-field-wrapper_input ${inputClassName} `;

        if (className) {
            wrapperClass += ' ' + className;
        }

        if (isActive || value || required || error) {
            placeholder = '';
            labelClass += ' visible-with-opacity';
        }

        if (!value) {
            inputClass += ' empty ';
        }

        if (sizeType) {
            wrapperClass += ' text-field-wrapper_' + sizeType;
        }

        if (disabled) {
            wrapperClass += ' disabled';
        }

        if (info) {
            wrapperClass += ' text-field-wrapper_info';
            msg = info;
        }

        if (error) {
            invalidClass = 'invalid';
            inputClass += invalidClass;
            msg = error;
        }

        if (this.isPassword()) {
            if (!isPasswordVisible) {
                appliedType = 'password';
            } else {
                appliedType = 'text';
            }

            inputClass += ' has-icon';
        }

        return (
            <div className={wrapperClass}>
                <label
                    className={`${labelClass} ${required && 'required'} ${isActive && 'active'} ${invalidClass}`}
                    title={required && 'Required field'}
                    htmlFor={name}>
                    {msg}
                </label>
                <input
                    style={{
                        height: height,
                        minHeight: height,
                        maxHeight: height,
                    }}
                    type={appliedType}
                    className={inputClass}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    autoFocus={autoFocus}
                    value={value}
                    readOnly={readOnly}
                    name={name}
                    maxLength={maxLength}
                    tabIndex={tabIndex}
                    id={id}
                    ref="input"
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    onKeyDown={this.onKeyDown}
                    onKeyUp={this.onKeyUp}
                    onInput={onInput}
                    onChange={onChange} />
                {this.isPassword() ? (isPasswordVisible ?
                    <i className="icon icon-alan-eye-close"
                        title="Hide password"
                        onClick={this.togglePasswordVisibilityMode} /> :
                    <i className="icon icon-alan-eye-open"
                        title="Show password"
                        onClick={this.togglePasswordVisibilityMode} />) : ''}
            </div>
        );
    }
}

TextFieldWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onEnter: PropTypes.func,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
    //value: PropTypes.any,//temp fix for billing
    sizeType: PropTypes.string,
    error: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string
};

export default TextFieldWrapper;
